// Webpack Imports
import bootstrap from 'bootstrap';
import './jss/sticky';
import lottieWeb from 'lottie-web';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
})();



(function (jQuery) {
  jQuery(document).ready(function () {
    jQuery('a').each(function () {
      if (location.hostname === this.hostname || 'geographicatrophy.eu' === this.hostname || !this.hostname.length || 'pre-lesion.com' === this.hostname ||  'geographicatrophy.com.au' === this.hostname ||  'dryamd.eu' === this.hostname ||  'apellis.com' === this.hostname || 'apellismedicalhub.com' === this.hostname) {
        jQuery(this).addClass('local');
      } else {
        jQuery(this).addClass('external');
      }
    });

    jQuery('a.external').click(function (e) {

      e.preventDefault();
      console.log("extern clicked");

      jQuery('#externalLink').addClass('show');

      var target = jQuery(this).attr('target');
      var uri = jQuery(this).attr('href');

      console.log("target, uri:", target, uri);

      jQuery('#externalLink .externalLink-ok').unbind();
      jQuery('#externalLink .externalLink-ok').click(function (e) {

        var link = document.createElement('a');
        link.href = uri;
        link.target = target;
        document.body.appendChild(link);
        link.click();

        jQuery('#externalLink').removeClass('show');

        return true;

      });

      jQuery('#externalLink .externalLink-close').unbind();
      jQuery('#externalLink .externalLink-close').click(function (e) {

        jQuery('#externalLink').removeClass('show');

        return true;

      });

    });

	  
	/**
	 * COOKIE BANNER
	 */
    const cookieBanner = jQuery('#cookieBanner');

    if (cookieBanner.length) {

      let cookieBannerClose = jQuery('.cookieBanner-close');
      let cookieBannerNo = jQuery('.cookieBanner-no');

      cookieBannerClose.on('click', function (e) {
        e.preventDefault();
        setCookie('cookieBanner', 'active', 365);
        cookieBanner.fadeOut();
      });

      cookieBannerNo.on('click', function (e) {
        e.preventDefault();
        setCookie('cookieBanner', 'no', 365);
        cookieBanner.fadeOut();
        // document.cookie = disableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
        // window[disableStr] = true;
      });
	}
	  
	  
	/**
	 * Professional
	 */
    const profBanner = jQuery('#profBanner');

    if (profBanner.length) {
		
      let profBannerClose = jQuery('.profBanner-close');

      profBannerClose.on('click', function (e) {
        e.preventDefault();
        setCookie('profBanner', 'active', 30);
        profBanner.fadeOut();
      });
	}

    
    const openPoll = jQuery('#openPoll');
    const pollBanner = jQuery('#pollBanner');

    if (openPoll.length) {
      let pollClose = jQuery('.pollBanner-close');

      pollClose.on('click', function (e) {
        e.preventDefault();
        pollBanner.removeClass('show');
      });

      jQuery('body').on('click', '.pollBanner-finish', function (e) {
        e.preventDefault();
        pollBanner.removeClass('show');
      });

      openPoll.on('click', function (e) {
        e.preventDefault();
        pollBanner.addClass('show'); 
      });
    }

    const openSignIn = jQuery('#openSignIn, a[href="#login-modal"]');
    const loginModal = jQuery('#loginModal');

    if (openSignIn.length) {
      let pollClose = jQuery('.loginModal-close');

      pollClose.on('click', function (e) {
        e.preventDefault();
        loginModal.removeClass('show');
      });

      jQuery('body').on('click', '.loginModal-finish', function (e) {
        e.preventDefault();
        loginModal.removeClass('show');
      });

      openSignIn.on('click', function (e) {
        e.preventDefault();
        loginModal.addClass('show');
      });
    }

    const openVideoModal = jQuery('.ga-cpd-perspectives .wp-block-media-text__media');
    const videoModal = jQuery('#videoModal');

    if (openVideoModal.length) {
      let videoCloseModal = jQuery('.videoModal-close');

      jQuery('body').on('click', '.videoModal-finish', function (e) {
        e.preventDefault();
        
        var $frame = videoModal.find("iframe");
        var vidsrc = $frame.attr('src');
        $frame.attr('src',''); 
        $frame.attr('src', vidsrc);
        
        videoModal.removeClass('show');
      });

      openVideoModal.on('click', function (e) {
        e.preventDefault();
        videoModal.addClass('show');
      });

      videoCloseModal.on('click', function (e) {
        e.preventDefault();

        var $frame = videoModal.find("iframe");
        var vidsrc = $frame.attr('src');
        $frame.attr('src',''); 
        $frame.attr('src', vidsrc);

        videoModal.removeClass('show');
      });

    }
	  
  });
})(jQuery);

function setCookie(name, value, days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

function eraseCookie(name) {
	document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}


var inViewport = [];

function stopOnElement() {
  var items = jQuery('.stickyColumns');
  
 
  items.each(function (index) {
    var rect = items[index].getBoundingClientRect();
    var items_count = jQuery(this).find('.stickyColumns__image').length;
    var this_height = jQuery(this).height();
    var inside = jQuery(this).find('.stickyColumns__images');
    var max_move = (window.innerHeight || document.documentElement.clientHeight) - this_height;
    var multiple = ((items_count - 1) * this_height) / max_move;
    if (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    ) {
      // console.log('inner:' + window.innerHeight);
      // console.log('h: ' + jQuery(this).height());
      // console.log(window.innerHeight - jQuery(this).height());
      // console.log('is in viewport ');
      // console.log('inside.height(): ' + inside.height());
      // console.log('jQuery(this).height(): ' + this_height);
      // console.log('max_move: ' + max_move);
      // console.log('rect.top: ' + rect.top);
      // console.log('multiple: ' + multiple);

      // console.log('ZZZZ: ' + (-1 * (((items_count - 1) * this_height) - ((multiple * rect.top)))) + 'px');

      if (rect.top < 30) {
        inside.stop().animate({ marginTop: -1 * ((items_count - 1) * this_height)}, 200);
        
      } else if (rect.top > max_move - 30) { 
        inside.stop().animate({ marginTop: '0' }, 200);
      } else {
        inside.css('margin-top', (-1 * (((items_count - 1) * this_height) - ((multiple * rect.top) ))) + 'px');
      }

      
    }

  });
}


// document.addEventListener('scroll', function () {
//   stopOnElement();

// }, {
//     passive: true
// });

  (function () {
    var supportOffset = window.pageYOffset !== undefined,
      lastKnownPos = 0,
      ticking = false,
      scrollDir,
      currYPos;

    function doSomething(scrollPos, scrollDir) {
      // Your code goes here...
      //console.log('scroll pos: ' + scrollPos + ' | scroll dir: ' + scrollDir);
    }

    window.addEventListener('wheel', function (e) {
      currYPos = supportOffset ? window.pageYOffset : document.body.scrollTop;
      scrollDir = lastKnownPos > currYPos ? 'up' : 'down';
      lastKnownPos = currYPos;

      if (!ticking) {
        window.requestAnimationFrame(function () {
          doSomething(lastKnownPos, scrollDir);
          ticking = false;
        });
      }
      ticking = true;
    });
  })();





let videoPlayers = jQuery('.video-player');

if (videoPlayers.length) {
    videoPlayers.each(function () {
      const videoBlock = jQuery(this).find('.wp-block-video');
      const videoButtons = jQuery(this).find('.specialButton__button');
        videoBlock.hide();
        videoBlock.eq(0).show();
      //videoBlock.eq(0).find('video').attr('poster', WPURL.themeuri + '/assets/img/poster.png');


      videoButtons.each(function (index) { 
        jQuery(this).on('click', function (e) {
          e.preventDefault();
          //videoPlayers.hide();
          videoBlock.each(function () {
            jQuery(this).hide();
          });
          console.log(index);
          videoBlock.eq(index).show();
        });
      });

    });
}


const lottie = jQuery('.lottie');

if (lottie.length) {

  const texts = jQuery('.lottie__text');
  let current_percent = 0;
  const howMany = jQuery('.lottie__trackItem').length;
  let lottieHeight = lottie.height();
  let margins = lottieHeight * 0.10;
  let whereStart = lottie.position().top - margins;
  let availableSpace = (lottieHeight - margins) / howMany;

  var animation = lottieWeb.loadAnimation({
    container: document.getElementById('lottie'),
    path: WPURL.themeuri + '/assets/lottie/progression.json',
    renderer: 'svg',
    loop: true,
    autoplay: false,
    name: "Animation Desktop",
  });

  var animation1 = lottieWeb.loadAnimation({
    container: document.getElementById('lottie-1'),
    path: WPURL.themeuri + '/assets/lottie/progression.json',
    renderer: 'svg',
    loop: true,
    autoplay: true,
    name: "Animation 1",
    initialSegment: [0, 74],
  });

  
  var animation2 = lottieWeb.loadAnimation({
    container: document.getElementById('lottie-2'),
    path: WPURL.themeuri + '/assets/lottie/progression.json',
    renderer: 'svg',
    loop: true,
    autoplay: true,
    name: "Animation 2",
    initialSegment: [75, 164],
    });
  
  var animation3 = lottieWeb.loadAnimation({
    container: document.getElementById('lottie-3'),
    path: WPURL.themeuri + '/assets/lottie/progression.json',
    renderer: 'svg',
    loop: true,
    autoplay: true,
    name: "Animation 3",
    initialSegment: [165, 239],
  });
  
  texts.eq(0).addClass('animOpacity');


  // lottie.find('.prev').on('click', function (e) {
  //   e.preventDefault();
  //   let scrollToPosition = 0;
  //   if (current_percent < 52) {
  //     scrollToPosition = ((availableSpace * (howMany - 1)) / 100 * 0) +  lottie.position().top;
  //   } else if (current_percent > 52) {
  //     scrollToPosition = ((availableSpace * (howMany - 1)) / 100 * 50) +  lottie.position().top;
  //   }

  //   jQuery([document.documentElement, document.body]).animate({
  //       scrollTop: scrollToPosition
  //   }, 500);
  // });

  // lottie.find('.next').on('click', function (e) {
  //   e.preventDefault();
  //   let scrollToPosition = 0;
  //   if (current_percent < 48) {
  //     scrollToPosition = ((availableSpace * (howMany - 1)) / 100 * 50) +  lottie.position().top;
  //   } else if (current_percent > 48) {
  //     scrollToPosition = ((availableSpace * (howMany - 1)) / 100 * 100) +  lottie.position().top;
  //   }
    
  //   jQuery([document.documentElement, document.body]).animate({
  //       scrollTop: scrollToPosition
  //   }, 500);
  // });

  jQuery(window).scroll(function () {



    
    let percent = ((jQuery(window).scrollTop() - lottie.position().top) / ((availableSpace * (howMany - 1)))) * 100;
    current_percent = percent;
    let calculated = ((availableSpace * (howMany - 1)) / 100 * percent ) +  lottie.position().top;

    
    if (percent > 100) {
      percent = 100;
    } else if (percent < 0) {
      percent = 0;
    }

    console.log(percent);

    if (jQuery(window).scrollTop() >= whereStart) {

      animation.goToAndStop((Math.round((percent/100) * 239)), true)

      let i = 0;
      for(i; i < howMany; i++) {
        if (jQuery(window).scrollTop() >= whereStart + (availableSpace * i)) {
          jQuery('.lottie__trackItem').removeClass('active');
          jQuery('.lottie__trackItem').eq(i).addClass('active');
          texts.removeClass('animOpacity');
          texts.eq(i).addClass('animOpacity');
     

        } 
      }




      jQuery('.lottie__trackCurrent').css('width', percent + '%');
    }
    
    // if(jQuery(window).scrollTop() >= whereStart) {
    //   console.log('start');


    //   let trackCurrentWidth = ((jQuery(window).scrollTop() - margins) / (lottieHeight - (availableSpace) - (margins * 2))) * 100;
    //   //console.log('trackCurrentWidth: ' + trackCurrentWidth);

    //   if (trackCurrentWidth < 0) {
    //     trackCurrentWidth = 0;
    //   } else if(trackCurrentWidth > 100) {
    //     trackCurrentWidth = 100;
    //   }

    //   jQuery('.lottie__trackCurrent').css('width', trackCurrentWidth + '%');



    //   let page = (jQuery(window).scrollTop() - (margins * 2) / availableSpace);
    //   console.log(page);



    //    let i = 0;
    //   for (i; i < howMany; i++) {

    //     if ((i + 1) * 1000 - 200 > page && (i + 1) * 1000 + 200 < page) {

    //         jQuery('.lottie__trackItem').eq(i).addClass('active');
    //     } else {

    //         jQuery('.lottie__trackItem').eq(i).removeClass('active');
    //       }
    //     }
      
      
    //   // console.log('whereStart: ' + whereStart);
    //   // console.log('lottieHeight: ' + lottieHeight);
    //   // console.log('space availabe: ' + availableSpace);
    //   // console.log('jQuery(window).scrollTop(): ' + jQuery(window).scrollTop());
      
    //   console.log('page: ' + page);

      
    // }

});
}


// Set to the same value as the web property used on the site
// var gaProperty = 'UA-XXXX-Y';

// Disable tracking if the opt-out cookie exists.
// var disableStr = 'ga-disable-' + gaProperty;
// if (document.cookie.indexOf(disableStr + '=true') > -1) {
//   window[disableStr] = true;
//   jQuery('#gaswitcher input[type="checkbox"]').prop('checked', true);
// }
// jQuery('#gaswitcher input[type="checkbox"]').bind('change', function (v) {
//   console.log('working');
//         if(jQuery(this).is(':checked')) {
//            document.cookie = disableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
//     window[disableStr] = true;
//      console.log('set true');
//         } else {
//               document.cookie = disableStr + '=true; expires=Thu, 01 Jan 1970 00:00:01  UTC; path=/';
//     window[disableStr] = false;
//     console.log('set false');
//         }
// });
    



  const forgotPasswordLink = jQuery('#wpuf-login-form > a');

  if (forgotPasswordLink.length) {
    forgotPasswordLink.eq(1).text('Forgot your password?');

  }

const loginForm = jQuery('#wpuf-login-form');

  if (loginForm.length) {
    loginForm.append(' |');

  }


const openNext = jQuery('.open-next');

if (openNext.length) {
  openNext.each(function () {
    jQuery(this).on('click', function (e) {
      e.preventDefault();

      jQuery(this).addClass('is-open');
      jQuery(this).prev('.to-be-opened').addClass('is-open');
    });
  });
}

jQuery(document).on('click','.wpuf-success',function(e) {
    e.preventDefault();
    jQuery(this).hide();
});

jQuery(document).on('click','.wpuf-error',function(e) {
    e.preventDefault();
    jQuery(this).hide();
});


function getUrlValue(varName) {
  var split = jQuery(location).attr('href').split('?');
    var value = '';
    if (split.length == 2) {
        split = split[1].split('&');
        for (var i = 0; i < split.length; i+=1) {
            var keyValue = split[i].split('=');
            if (keyValue.length == 2 && keyValue[0] == varName) {
                value = keyValue[1];
                break;
            }
        }
    }
    return value;
}


(function (jQuery) {
  let _get_id = getUrlValue('id');

  if (_get_id !== '') {
    if (jQuery('input[name=user_source]')) {
      jQuery('input[name=user_source]').val(_get_id);
    }
  }

  if (jQuery("input[name = first_name]").length) {
    jQuery("input[name =first_name]").keyup(function () {
      jQuery("input[name = hidden_first_name]").val(jQuery("input[name = first_name]").val());
    });
  }

  if (jQuery("input[name = user_email]").length) {
    jQuery("input[name = user_email]").keyup(function () {
      jQuery("input[name = hidden_email]").val( jQuery("input[name = user_email]").val());
    });
  }

  if (jQuery("input[name = last_name]").length) {
    jQuery("input[name = last_name]").keyup(function () {
      jQuery("input[name = hidden_last_name]").val(jQuery("input[name = last_name]").val());
    });
  }

}(jQuery));


(function ($, root, undefined) {
  $(function () {

  let mcnz_field = $('input[name="mcnz_number"]');
  if(mcnz_field) {
    mcnz_field.attr("pattern", "^\\d{5}$|^\\d{2}-\\d{5}$");
    mcnz_field.attr("title", "Please enter a valid MCNZ/ODOB number (5 numeric or 2 numeric dash 5 numeric)");
  
    mcnz_field.on("invalid", function(e){
      $(this).closest('div').addClass('has-error');
      $(this).siblings('.wpuf-error-msg').remove();
      $(this).after('<div class="wpuf-error-msg">Please enter a valid MCNZ/ODOB number (5 numeric or 2 numeric dash 5 numeric)</div>')
      $(this).focus();

      e.preventDefault();
      console.log("invalid mcnz");
    });  
  }

  let ahpra_field = $('input[name="ahpra_number"]');
  if(ahpra_field) {
    ahpra_field.attr("pattern", "^[a-zA-Z]{3}\\d{10}$");
    ahpra_field.attr("title", "Please enter a valid AHPRA number (3 alpha-numeric followed by 10 numeric)");
  
    ahpra_field.on("invalid", function(e){
      $(this).closest('div').addClass('has-error');
      $(this).siblings('.wpuf-error-msg').remove();
      $(this).after('<div class="wpuf-error-msg">Please enter a valid AHPRA number (3 alpha-numeric followed by 10 numeric)</div>')
      $(this).focus();

      e.preventDefault();
      console.log("invalid ahpra");
    });  
  }

  let password_field = $('input[name="pass1"]');
  if(password_field) {
    password_field.attr("pattern", "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^\\da-zA-Z]).{8,}$");
    password_field.attr("title", "Minimum 8 characters, with numbers, uppercase and lowercase and at least 1 special character.");

    password_field.on("invalid", function(e){
      $(this).closest('div').addClass('has-error');
      $(this).siblings('.wpuf-error-msg').remove();
      $(this).after('<div class="wpuf-error-msg">Minimum 8 characters, with numbers, uppercase and lowercase and at least 1 special character.</div>')
      $(this).focus();

      e.preventDefault();
      console.log("invalid password");
    });  
  }

  // Resources
  $('input[name=audience]').on("change", function () {
    var classification = $('input[name=audience]:checked').val();
    var search = $('input[id="search-resources"]').val();

    classification = classification === 'all' ? '' : classification;
    runSearchQueryResources(classification, search, 0);
  });

  $('#search-resources').on("input", function () {
    var classification = $('input[name=audience]:checked').val();
    var search = $('input[id="search-resources"]').val();

    classification = classification === 'all' ? '' : classification;
    runSearchQueryResources(classification, search, 0);
  });

  setLoadMoreButtonResources();
  function setLoadMoreButtonResources() {
    $('section.resources button[loadprojects]').on("click", function () {
      var offset = $('section.resources .resource-row').length;
      var classification = $('input[name=audience]:checked').val();
      var search = $('input[id="search-resources"]').val();

      classification = classification === 'all' ? '' : classification;
      $('section.resources .projects .loading[type="view_more"]').show();
      runSearchQueryResources(classification, search, offset);
    });
  }

  function runSearchQueryResources(classification, search, offset) {
    if (!offset) {
      $('section.resources .projects').html('<div class="loading"></div>');
    }
    $.ajax({
      type: "GET",
      url: '/wp-admin/admin-ajax.php',
      data: {
        'action': 'get_resources',
        'classification': classification,
        'search': search,
        'offset': offset
      },
      success: function (response) {
        $('section.resources .projects .loading[type="view_more"]').remove();
        if (offset) {
          $('.button-container').remove();
          $('section.resources .projects').append(response);
          setLoadMoreButtonResources();
        } else {
          $('section.resources .projects').html(response);
          setLoadMoreButtonResources();
        }
      }
    });
  }

  $("section.resources select").on("change", function () {
    var language = $(this).val();
    $(this).closest(".resource-row").attr("language", language);

    $(this).closest(".resource-row").find(".button-group").each(function() {
      if ($(this).attr("language") == language) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });

  });

  // // // //

  $('input[name=media], select[name=topic]').on("change", function () {
    var media = $('input[name=media]:checked').val();
    var topic = $('select[name=topic]').val();

    console.log("y");

    media = media === 'all' ? '' : media;
    topic = topic === 'all' ? '' : topic;
    runSearchQueryWebinarsPodcasts(media, topic, 0);
  });

  setLoadMoreButtonWebinarsPodcasts();
  function setLoadMoreButtonWebinarsPodcasts() {
    $('section.webinarspodcasts button[loadprojects]').on("click", function () {
      var offset = $('section.webinarspodcasts .webinarpodcast-row').length;
      var media = $('input[name=media]:checked').val();
      var topic = $('select[name=topic]').val();

      media = media === 'all' ? '' : media;
      topic = topic === 'all' ? '' : topic;

      $('section.webinarspodcasts .projects .loading[type="view_more"]').show();
      runSearchQueryWebinarsPodcasts(media, topic, offset);
    });
  }

  function runSearchQueryWebinarsPodcasts(media, topic, offset) {
    if (!offset) {
      $('section.webinarspodcasts .projects').html('<div class="loading"></div>');
    }
    $.ajax({
      type: "GET",
      url: '/wp-admin/admin-ajax.php',
      data: {
        'action': 'get_webinarspodcasts',
        'media': media,
        'topic': topic,
        'offset': offset
      },
      success: function (response) {
        $('section.webinarspodcasts .projects .loading[type="view_more"]').remove();
        if (offset) {
          $('.button-container').remove();
          $('section.webinarspodcasts .projects').append(response);
          setLoadMoreButtonWebinarsPodcasts();
        } else {
          $('section.webinarspodcasts .projects').html(response);
          setLoadMoreButtonWebinarsPodcasts();
        }
      }
    });
  }

  $('.update-profile input[name="subscribe_checkbox"').on("click", function() {
    console.log($(this).is(':checked'));
    if ($(this).is(':checked')) {
      $(this).closest(".update-profile").find('input[name="subscribe"]').attr("value", "true");
    } else {
      $(this).closest(".update-profile").find('input[name="subscribe"]').attr("value", "false");
    }
  });

  $('.mobile-menu .link-dropdown .dropdown').on("click", function() {
    $(this).closest(".mobile-menu").find(".row-menu:not(.link-dropdown)").toggle();
    $(this).closest(".mobile-menu").find(".link-dropdown .dropdown").toggleClass("active");
  });

  $("form.wpuf-form-add .wpuf-submit input[type='submit']").on("click", function() {
    console.log("error-start");
    // has-error
    // wpuf-error-msg
    $("form.wpuf-form-add .wpuf-el input").each(function() {
      switch ($(this).attr("type")) {
        case "text" :
        case "email" :
        case "password" :
          if (!$(this).val()) {
            $(this).closest('div').addClass('is-empty');
            $(this).siblings('.is-empty-msg').remove();
            $(this).after('<div class="is-empty-msg">' + $(this).closest('.wpuf-el').attr("data-label") + ' is required</div>');
          } else {
            $(this).closest('div').removeClass('is-empty');
            $(this).siblings('.is-empty-msg').remove();
          }
          break;
        case "checkbox" :
          if (!($(this).is(":checked"))) {
            console.log($(this));
            $(this).closest('div').addClass('is-empty');
            $(this).closest('label').siblings('.is-empty-msg').remove();
            $(this).closest('label').after('<div class="is-empty-msg">Please tick this box if you want to proceed</div>')
          }
          else {
            $(this).closest('div').removeClass('is-empty');
            $(this).closest('label').siblings('.is-empty-msg').remove();
          }
      }
  
    });
  
    $("form.wpuf-form-add .wpuf-el select").each(function() {
      if ($(this).val() == -1) {
        $(this).closest('div').addClass('is-empty');
        $(this).siblings('.is-empty-msg').remove();
        $(this).after('<div class="is-empty-msg">' + $(this).closest('.wpuf-el').attr("data-label") + ' is required</div>')
      } else {
        $(this).closest('div').removeClass('is-empty');
        $(this).siblings('.is-empty-msg').remove();
      }
    });

    console.log("this");
    debugger;

  });

  $(".modal.loginModal form input[name='wp-submit']").on("click", function(e) {
    console.log("error-start");

    $(".modal.loginModal form input").each(function() {
      switch ($(this).attr("type")) {
        case "text" :
          if (!$(this).val()) {
            $(this).closest('div').addClass('is-empty');
            $(this).siblings('.is-empty-msg').remove();
            $(this).after('<div class="is-empty-msg">Email is required</div>');
          } else {
            $(this).closest('div').removeClass('is-empty');
            $(this).siblings('.is-empty-msg').remove();
          }
          break;
        case "password" :
          if (!$(this).val()) {
            $(this).closest('div').addClass('is-empty');
            $(this).siblings('.is-empty-msg').remove();
            $(this).after('<div class="is-empty-msg">Password is required</div>');
          } else {
            $(this).closest('div').removeClass('is-empty');
            $(this).siblings('.is-empty-msg').remove();
          }
          break;
      }
  
    });

    if (!($(".modal.loginModal form input[type=text]").val()) || !($(".modal.loginModal form input[type=password]").val())) {
      e.preventDefault();
    }
  });

  $('#analytics-checkbox').on('change', function() {
    var analyticsEnabled = $(this).prop('checked');
    
    if (analyticsEnabled) {
      document.cookie = "analytics_enabled=true; expires=" + new Date(new Date().getTime() + 3600 * 24 * 365 * 1000).toUTCString() + "; path=/";
    } else {
      document.cookie = "analytics_enabled=false; expires=" + new Date(new Date().getTime() + 3600 * 24 * 365 * 1000).toUTCString() + "; path=/";
    }
    
    location.reload();
  });

  $('#functional-cookie-checkbox').on('change', function() {
    var functionalCookiesEnabled = $(this).prop('checked');
    
    if (functionalCookiesEnabled) {
      document.cookie = "functional_cookies=true; expires=" + new Date(new Date().getTime() + 3600 * 24 * 365 * 1000).toUTCString() + "; path=/";
    } else {
      document.cookie = "functional_cookies=false; expires=" + new Date(new Date().getTime() + 3600 * 24 * 365 * 1000).toUTCString() + "; path=/";
    }
    
    location.reload();
  });

  function setAnalyticsCookie(value) {
    console.log("Set " + value);
    document.cookie = "analytics_enabled=" + value + "; expires=" + new Date(new Date().getTime() + 3600 * 24 * 365 * 1000).toUTCString() + "; path=/";

    if (value == 'false') {
      location.reload();
    }
  }

  function setFunctionalCookie(value) {
    console.log("Set functional cookie to " + value);
    document.cookie = "functional_cookies=" + value + "; expires=" + new Date(new Date().getTime() + 3600 * 24 * 365 * 1000).toUTCString() + "; path=/";
  
    if (value == 'false') {
      location.reload();
    }
  }

  function updateCheckboxState() {
    const checkbox = $('#analytics-checkbox');
    const analyticsEnabled = getCookie('analytics_enabled');
    checkbox.prop('checked', analyticsEnabled === 'true');
  }

  function updateFunctionalCheckboxState() {
    const checkbox = $('#functional-cookie-checkbox');
    const functionalCookiesEnabled = getCookie('functional_cookies');
    checkbox.prop('checked', functionalCookiesEnabled === 'true');
  }
  
  function getCookie(name) {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(name + '=')) {
        return cookie.substring(name.length + 1);
      }
    }
    return '';
  }

  $(document).ready(function() {
    $('#accept-cookies').click(function() {
      setAnalyticsCookie('true');
      setFunctionalCookie('true');
      updateCheckboxState();
      updateFunctionalCheckboxState();
    });

    $('#reject-cookies').click(function() {
      setAnalyticsCookie('false');
      setFunctionalCookie('false');
      updateCheckboxState();
      updateFunctionalCheckboxState();
    });

    updateCheckboxState();
    updateFunctionalCheckboxState();
  });

});

})(jQuery, this);